// Application Constants for simplified single-establishment model

// Official Artevo public creation URL
export const OFFICIAL_CREATE_URL = '/e/qr-cadre-personnalis-60cf51e6';

// Artevo payment phone number for proof of payment
export const ARTEVO_PAYMENT_PHONE = '+2250576453095';

// Hours before unpaid orders are automatically deleted
export const ORDER_CLEANUP_HOURS = 24;

// Artevo admin email (unique establishment owner)
export const ARTEVO_ADMIN_EMAIL = 'da.entrprise@gmail.com';
